module.exports = __webpack_public_path__ + "img/userInput.a1b113ac.svg";